import { Component, ChangeDetectionStrategy, input, output, signal, effect } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'widget-toggle',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="toggle-satir" [class.devre-disi]="devre_disi()">
      @if (etiket()) { <span class="toggle-etiket">{{ etiket() }}</span> }
      <div class="toggle-switch" [class.acik]="ic_deger()"
           [style.--tgl-renk]="renk()"
           (click)="tikla()">
        <span class="toggle-thumb"></span>
      </div>
    </div>
  `,
  styles: [`
    :host { display: block; }
    .toggle-satir {
      display: flex; align-items: center; justify-content: space-between;
      gap: 10px; user-select: none;
    }
    .toggle-etiket {
      font-size: 13px; font-weight: 500; color: var(--py-metin, #e0e0e0);
      white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
      flex: 1; min-width: 0;
    }
    .toggle-switch {
      position: relative; flex-shrink: 0;
      width: 44px; height: 24px; border-radius: 12px;
      background: rgba(255,255,255,0.12);
      cursor: pointer;
      transition: background 0.25s ease;
    }
    .toggle-switch.acik {
      background: var(--tgl-renk, #52c41a);
    }
    .toggle-thumb {
      position: absolute; top: 2px; left: 2px;
      width: 20px; height: 20px; border-radius: 50%;
      background: #fff;
      box-shadow: 0 1px 4px rgba(0,0,0,0.3);
      transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    }
    .toggle-switch.acik .toggle-thumb {
      transform: translateX(20px);
    }
    .toggle-switch:hover { filter: brightness(1.08); }
    .toggle-switch:active .toggle-thumb { width: 24px; }
    .toggle-switch.acik:active .toggle-thumb {
      width: 24px; transform: translateX(16px);
    }
    .devre-disi {
      opacity: 0.45; pointer-events: none; cursor: not-allowed;
    }
  `],
})
export class ToggleComponent {
  deger = input(false);
  etiket = input('');
  devre_disi = input(false);
  renk = input('#52c41a');
  degisti = output<boolean>();

  ic_deger = signal(false);

  constructor() {
    effect(() => this.ic_deger.set(this.deger()));
  }

  tikla() {
    if (this.devre_disi()) return;
    const yeni = !this.ic_deger();
    this.ic_deger.set(yeni);
    this.degisti.emit(yeni);
  }
}
